import { render } from "./Formato2023.vue?vue&type=template&id=50e6c232&scoped=true"
import script from "./Formato2023.vue?vue&type=script&lang=js"
export * from "./Formato2023.vue?vue&type=script&lang=js"

import "./Formato2023.vue?vue&type=style&index=0&id=50e6c232&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e6c232"]])

export default __exports__